import { Component, Inject, Input } from "@angular/core";

import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-ktostamm-lieferant-field-ok-data-view',
    imports: [],
    templateUrl: './ktostamm-lieferant.list-view.html',
    styleUrls: ['./ktostamm-lieferant.list-view.css']
})
export class KtostammLieferantListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
